import { logoConstants } from "../_constants";

export const logoActions = {
  logo,
};

function logo(message) {
  return { type: logoConstants.LOGO, message };
}
